export const WORK_EMAIL_MESSAGE =
  "Use a business email address. Personal inboxes such as Gmail, Outlook, and Yahoo are not accepted.";

// Consumer and disposable inboxes. Company domains (including example.com for tests) stay allowed.
const PERSONAL_EMAIL_DOMAINS = new Set([
  "gmail.com",
  "googlemail.com",
  "hotmail.com",
  "hotmail.co.uk",
  "hotmail.fr",
  "hotmail.de",
  "hotmail.it",
  "outlook.com",
  "outlook.in",
  "outlook.co.uk",
  "live.com",
  "live.co.uk",
  "msn.com",
  "yahoo.com",
  "yahoo.co.uk",
  "yahoo.co.in",
  "yahoo.fr",
  "yahoo.de",
  "ymail.com",
  "rocketmail.com",
  "icloud.com",
  "me.com",
  "mac.com",
  "aol.com",
  "aim.com",
  "proton.me",
  "protonmail.com",
  "protonmail.ch",
  "pm.me",
  "gmx.com",
  "gmx.net",
  "gmx.de",
  "mail.com",
  "email.com",
  "yandex.com",
  "yandex.ru",
  "rediffmail.com",
  "inbox.com",
  "mail.ru",
  "qq.com",
  "163.com",
  "126.com",
  "hey.com",
  "mailinator.com",
  "guerrillamail.com",
  "10minutemail.com",
  "tempmail.com",
  "yopmail.com",
  "trashmail.com",
  "sharklasers.com",
]);

export function isWorkEmail(email) {
  const value = String(email || "").trim().toLowerCase();
  const at = value.lastIndexOf("@");
  if (at < 1 || at === value.length - 1) return false;
  const domain = value.slice(at + 1);
  return Boolean(domain) && !PERSONAL_EMAIL_DOMAINS.has(domain);
}
